import React from 'react'
import { Parameter } from './apireftypes';
import { ApiParameter } from './apiparameter';
import './apiendpoint.css';
import './apiparameter.css';

interface Props {
    parameters : Parameter[];
}

export class ApiParameters extends React.Component<Props> {

    render() {
        return (
            <div className="parameters">
                <h2>Parameters</h2>
                { this.renderParameters(this.props.parameters) }
            </div>
        )
    }

    renderParameters(parameters : Parameter[]) :  React.JSX.Element[]
    {
        let elements : React.JSX.Element[] = [];

        for (let i = 0; i < parameters.length; i++) {
            elements.push(<ApiParameter key={ parameters[i].name } parameter={ parameters[i] } />);
        }

        return elements;
    }
}

